import React from 'react';
import { t } from 'Src/i18n';
type Props = {
  arrivalDate?: string | null | undefined;
  departureDate?: string | null | undefined;
};
export const ArrivalDepartureDate = ({ arrivalDate, departureDate }: Props) => (
  <div className="block p-10 text-14 sm:hidden">
    <p className="mb-5 flex justify-between gap-5">
      {t('faceting.when.arrivalDateTitle')}
      <span className="font-bold text-sienna">{arrivalDate ? arrivalDate : ' -'}</span>
    </p>
    <p className="flex justify-between gap-5">
      {t('faceting.when.departureDateTitle')}
      <span className="font-bold text-sienna">{departureDate ? departureDate : ' -'}</span>
    </p>
  </div>
);
